var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"personality-test-jobseeker"},[_c('div',{staticStyle:{"width":"80%","margin":"0 auto","max-width":"900px"}},[_c('Test')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }